import anime from 'animejs';
import { SplitText } from '@/assets/libs/SplitText';
import { isIOS } from '@/scripts/utils';

export function titleInit(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  if (!elToTween._isSplit) { // eslint-disable-line
    const split = new SplitText(elToTween, { type: 'chars, lines', charsClass: 'title__char', linesClass: 'title__line' });
    elToTween._splitInstance = split; // eslint-disable-line
  }
  const lineBounding = elToTween.querySelector('.title__line') !== null
    ? elToTween.querySelector('.title__line').getBoundingClientRect() : elToTween.getBoundingClientRect();
  let origin = `50% 50% -${lineBounding.height / 2}px`;
  if (isIOS() || window.safari) {
    origin = '50% 50%';
  }
  const chars = [...elToTween.querySelectorAll('.title__char')];
  const tween = anime.set(chars, { rotateX: -95, transformOrigin: [origin, origin] });

  return tween;
}

export function titleAnim(el, delay = 0) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const lineBounding = elToTween.querySelector('.title__line') !== null
    ? elToTween.querySelector('.title__line').getBoundingClientRect() : elToTween.getBoundingClientRect();
  let origin = `50% 50% -${lineBounding.height / 2}px`;
  if (isIOS() || window.safari) {
    origin = '50% 50%';
  }
  const chars = [...elToTween.querySelectorAll('.title__char')];
  const tween = anime({
    targets: chars,
    rotateX: 0,
    rotateY: 0,
    rotateZ: 0,
    transformOrigin: [origin, origin],
    delay: anime.stagger(30, { start: delay }),
    complete: () => {
      // elToTween._splitInstance.revert();
      elToTween.setAttribute('data-animated', '');
    },
  });

  return tween;
}
